<template>
  <div class="apply-loan-h5">
    <div>
      <!-- 基本信息确认界面 -->
      <div v-if="currentStep === 1">
        <div class="info-confirm-card">
          <div class="info-header">
            <h3>基本信息确认</h3>
          </div>
          <div class="info-content">
            <div class="info-section">
              <div class="info-row">
                <span class="info-label"
                  >{{ identityTypeCode === "2" ? "姓名" : "主体名称" }}：</span
                >
                <span class="info-value">{{
                  applicantInfo.mainName || "未填写"
                }}</span>
              </div>
              <div class="info-row">
                <span class="info-label"
                  >{{
                    identityTypeCode === "2" ? "身份证号" : "统一社会信用代码"
                  }}：</span
                >
                <span class="info-value">{{
                  applicantInfo.creditCode || "未填写"
                }}</span>
              </div>
              <div v-if="identityTypeCode !== '2'" class="info-row">
                <span class="info-label">法定代表人：</span>
                <span class="info-value">{{
                  applicantInfo.legalPerson || "未填写"
                }}</span>
              </div>
              <div v-if="identityTypeCode !== '2'" class="info-row">
                <span class="info-label">联系人姓名：</span>
                <span class="info-value">{{
                  applicantInfo.contactName || "未填写"
                }}</span>
              </div>
              <div class="info-row">
                <span class="info-label"
                  >{{
                    identityTypeCode === "2" ? "手机号" : "联系人手机号"
                  }}：</span
                >
                <span class="info-value">{{
                  applicantInfo.contactPhone || "未填写"
                }}</span>
              </div>
              <div v-if="identityTypeCode !== '2'" class="info-row">
                <span class="info-label">法人手机号：</span>
                <span class="info-value">{{
                  applicantInfo.legalPersonPhone || "未填写"
                }}</span>
              </div>
            </div>

            <!-- 营业执照 -->
            <div v-if="identityTypeCode !== '2'" class="info-section">
              <div class="info-row">
                <span class="info-label">营业执照：</span>
                <span class="info-value">
                  <van-uploader
                    v-model="fileList.businessLicense"
                    :max-count="1"
                    :deletable="false"
                    :show-upload="false"
                    :preview-size="60"
                    class="compact-uploader"
                  />
                </span>
              </div>
            </div>

            <!-- 身份证/法人身份证 -->
            <div class="info-section">
              <div class="info-row">
                <span class="info-label"
                  >{{
                    identityTypeCode === "2" ? "身份证" : "法人身份证"
                  }}：</span
                >
                <span class="info-value">
                  <van-uploader
                    v-model="fileList.legalPersonIdCard"
                    :max-count="2"
                    :deletable="false"
                    :show-upload="false"
                    :preview-size="60"
                    class="compact-uploader"
                  />
                </span>
              </div>
            </div>
          </div>

          <div class="info-footer">
            <p class="info-tip">
              提示：以上信息从平台用户信息自动获取，如有变更请前往个人信息页面修改
            </p>
          </div>
        </div>
        <div class="button-group">
          <van-button type="primary" block @click="nextStep">下一步</van-button>
        </div>
      </div>

      <!-- 贷款申请信息和补充材料界面 -->
      <div v-else-if="currentStep === 2">
        <van-cell-group title="贷款申请信息">
          <van-field
            v-model="loanInfo.amount"
            label="贷款申请金额"
            placeholder="请输入金额"
            type="number"
            required
          >
            <template #extra>
              <span class="unit-text">万元</span>
            </template>
          </van-field>
          <van-field
            v-model="loanInfo.term"
            label="贷款期限"
            placeholder="请输入期限"
            type="number"
            required
          >
            <template #extra>
              <span class="unit-text">月</span>
            </template>
          </van-field>
          <van-field
            v-model="loanInfo.operatingYears"
            label="经营年限"
            placeholder="请输入年限"
            type="number"
            required
          >
            <template #extra>
              <span class="unit-text">年</span>
            </template>
          </van-field>
          <van-field
            v-model="loanInfo.annualTurnover"
            label="年营业额"
            placeholder="请输入营业额"
            type="number"
            required
          >
            <template #extra>
              <span class="unit-text">万元</span>
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            label="贷款资金用途"
            :value="loanInfo.purpose"
            placeholder="选择用途"
            required
            @click="showPurposePicker = true"
          />
          <van-field
            v-model="loanInfo.purposeDescription"
            label="用途说明"
            placeholder="请输入用途说明"
            type="textarea"
            rows="2"
            autosize
            required
          />

          <van-popup v-model="showPurposePicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="currentPurposeColumns"
              @confirm="onPurposeConfirm"
              @cancel="showPurposePicker = false"
            />
          </van-popup>
        </van-cell-group>

        <!-- 仓单质押逻辑 -->
        <van-cell-group
          v-if="productType === '仓单贷' && loanInfo.purpose"
          title="仓单质押信息"
        >
          <van-field
            v-model="pledgeInfo.warehouseReceiptNo"
            label="仓单号"
            placeholder="请选择仓单"
            readonly
            is-link
            required
            @click="showWarehouseList"
          />
          <van-field
            v-if="pledgeInfo.selectedWarehouse"
            v-model="pledgeInfo.pledgeQuantity"
            label="质押数量"
            placeholder="请输入质押数量"
            type="number"
            required
            @input="onPledgeQuantityInput"
          >
            <template #button>
              <span class="unit-kg">KG</span>
            </template>
            <template #extra>
              <span
                v-if="
                  pledgeInfo.selectedWarehouse &&
                  pledgeInfo.selectedWarehouse.balanceWeight > 0
                "
                class="balance-text"
              >
                可抵押: {{ pledgeInfo.selectedWarehouse.balanceWeight }}KG
              </span>
            </template>
          </van-field>
        </van-cell-group>

        <van-cell-group title="补充材料（可选）">
          <van-field>
            <template #input>
              <van-uploader
                v-model="fileList.supplementaryMaterials"
                :after-read="afterReadSupplementary"
                accept="image/*,.pdf"
                :preview-size="60"
              />
            </template>
          </van-field>
        </van-cell-group>

        <div class="button-group">
          <van-button type="primary" block @click="submit">提交</van-button>
          <van-button block @click="cancel">取消</van-button>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="showAgreementDialog"
      title="用户授权协议"
      show-cancel-button
      confirm-button-text="同意"
      cancel-button-text="不同意"
      @confirm="handleAgreementConfirm"
      @cancel="handleAgreementCancel"
    >
      <div class="agreement-content">
        <p>
          <strong>《用户信息授权协议》</strong
          >（以下简称"本协议"）是您（以下简称"用户"或"您"）与汇农服农事化服务平台（以下简称"平台"）及合作银行所订立的有效合约。
        </p>

        <p style="color: #e67e22; font-weight: bold; margin: 15px 0">
          请务必仔细阅读并充分理解本协议的全部内容，特别是加粗标出的条款。如果您不同意本协议的任何内容，或无法准确理解相关条款的含义，请不要进行确认操作。您勾选同意或通过页面点击确认等表示接受的行为，即视为您已阅读并同意本协议的全部约定。
        </p>

        <h4 style="margin: 20px 0 10px 0; color: #2c3e50">一、授权范围</h4>
        <p>
          您理解并同意，为了便于合作银行评估您的贷款申请，您在此授权平台将您在本平台产生的、与贷款审核相关的必要信息提供给合作银行。
        </p>
        <p>这些信息可能包括：</p>
        <ul style="margin: 10px 0 20px 20px">
          <li><strong>身份信息</strong>：如姓名、身份证号、联系方式；</li>
          <li>
            <strong>经营信息</strong
            >：如土地种植面积、作物类型、农资采购记录、农产品销售记录；
          </li>
          <li>
            <strong>交易数据</strong
            >：如在本平台的历史交易流水、销售额、客户评价；
          </li>
          <li>
            <strong>其他信息</strong
            >：平台基于提供服务和贷款评估需要，在法律法规允许范围内收集并经您授权的其他信息。
          </li>
        </ul>

        <h4 style="margin: 20px 0 10px 0; color: #2c3e50">二、授权使用目的</h4>
        <p>您所授权的信息将仅限于合作银行用于以下目的：</p>
        <ul style="margin: 10px 0 20px 20px">
          <li>审核您的涉农贷款申请资格；</li>
          <li>评估您的信用状况和还款能力；</li>
          <li>进行必要的贷后风险管理；</li>
          <li>法律法规允许及您与银行约定的其他用途。</li>
        </ul>
        <p>
          <strong
            >平台及合作银行承诺遵循合法、正当、必要的原则使用您的信息，不会将您的信息用于与本协议约定目的无关的其他商业用途。</strong
          >
        </p>

        <h4 style="margin: 20px 0 10px 0; color: #2c3e50">
          三、信息共享与保护
        </h4>
        <p>平台将通过加密等安全方式将您的信息提供给合作银行。</p>
        <p>
          平台会通过与银行签订协议等方式，要求银行承诺仅在实现本协议约定目的所必需的范围内处理您的信息，并采取有效措施保护您的信息安全，严格防止信息泄露和滥用。
        </p>
        <p>
          <strong
            >除非根据法律法规要求、司法或行政机构强制要求，或为维护公共利益、保护平台或银行合法权益所必需，未经您另行授权，平台与银行不会向任何其他第三方共享或提供您的信息。</strong
          >
        </p>

        <h4 style="margin: 20px 0 10px 0; color: #2c3e50">五、免责声明</h4>
        <p>
          因合作银行服务或其使用您的信息而产生的任何纠纷，或因银行服务违反相关法律法规或协议约定，导致您在使用银行服务过程中遭受损失的，应由银行独立承担相应责任，平台不对此承担责任。
        </p>
        <p>
          出现下列情形之一，造成用户信息丢失、泄露的，平台及合作银行不承担法律责任：
        </p>
        <ul style="margin: 10px 0 20px 20px">
          <li>
            任何由于黑客攻击、计算机病毒侵入或发作、政府管制等不可抗力造成的损失；
          </li>
          <li>
            因您自身原因（包括但不限于泄露账户密码、授权他人使用您的账户等）导致的损失；
          </li>
          <li>因战争、地震、火灾、恐怖袭击、罢工等不可抗力引起的任何后果。</li>
        </ul>

        <h4 style="margin: 20px 0 10px 0; color: #2c3e50">
          六、协议变更与生效
        </h4>
        <p>
          若本协议发生变更，我们将通过平台公示或另行通知的方式告知您。变更后的协议在公示期满或您确认同意后将成为本协议的有效组成部分。若您无法同意变更内容，您有权停止使用相关服务并撤回授权。
        </p>
        <p>
          本协议自您勾选同意之日起生效，至您成功撤回授权或您与银行的贷款法律关系终止后（以较晚者为准），法律法规另有规定的除外。
        </p>

        <h4 style="margin: 20px 0 10px 0; color: #2c3e50">七、争议解决</h4>
        <p>
          双方在履行本协议过程中如发生争议，应友好协商解决。协商不成的，任何一方均有权向本协议签订地（即平台运营主体所在地）有管辖权的人民法院提起诉讼。
        </p>

        <h4 style="margin: 20px 0 10px 0; color: #2c3e50">八、其他</h4>
        <p>
          本协议项下关于平台对您信息保护的通用规则，请参见平台在官方渠道发布的《隐私政策》。如需了解合作银行对您信息的处理规则，请您直接向该银行咨询。
        </p>

        <p
          style="
            color: #e67e22;
            font-weight: bold;
            margin-top: 20px;
            border-top: 1px solid #eee;
            padding-top: 15px;
          "
        >
          点击"同意并继续"即表示您已阅读并同意本授权协议的全部内容。
        </p>
      </div>
    </van-dialog>

    <!-- 仓单选择弹窗 -->
    <van-popup
      v-model="showWarehousePicker"
      round
      position="bottom"
      :style="{ height: '70%' }"
    >
      <div class="warehouse-picker">
        <div class="picker-header">
          <span class="picker-title">选择仓单</span>
          <van-icon
            name="cross"
            class="close-icon"
            @click="closeWarehouseList"
          />
        </div>

        <div class="warehouse-list">
          <div
            v-for="warehouse in warehouseList"
            :key="warehouse.id"
            class="warehouse-item"
            :class="{
              selected:
                tempSelectedWarehouse &&
                tempSelectedWarehouse.id === warehouse.id,
            }"
            @click="selectWarehouse(warehouse)"
          >
            <div class="warehouse-info">
              <div class="warehouse-no">{{ warehouse.warehouseReceiptNo }}</div>
              <div class="warehouse-details">
                <span class="warehouse-name">{{
                  warehouse.warehouseName
                }}</span>
                <span class="warehouse-product">{{
                  warehouse.productName
                }}</span>
              </div>
              <div class="warehouse-balance" v-if="warehouse.balanceWeight > 0">
                可抵押: {{ warehouse.balanceWeight }}KG
              </div>
            </div>
            <van-icon
              v-if="
                tempSelectedWarehouse &&
                tempSelectedWarehouse.id === warehouse.id
              "
              name="success"
              class="selected-icon"
            />
          </div>

          <div v-if="warehouseList.length === 0" class="empty-tips">
            <van-empty description="暂无仓单数据" />
          </div>
        </div>

        <div class="picker-footer">
          <van-button
            type="primary"
            block
            :disabled="!tempSelectedWarehouse"
            @click="confirmWarehouse"
          >
            确认选择
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import wx from "weixin-js-sdk";
import {
  farmerAndCompanyApply,
  financeTypeByIds,
  getWarehouseReceiptListH5,
} from "@/api/RuralFinance";
import { uploadFile } from "@/api/fileApi";
const baseUrl = window.globalUrl.BASE_API;
export default {
  name: "ApplyLoanH5",
  components: {},
  data() {
    return {
      currentStep: 1, // 当前步骤
      identityTypeCode: "",
      accessToken: "",
      identityId: "",
      loanTypeId: "",
      financeProductId: "",
      productType: "",
      productTypeId: null,
      productTypeOptions: [],
      purposePickerOptions: [],
      applicantInfo: {
        mainName: "",
        creditCode: "",
        legalPerson: "",
        contactName: "",
        contactPhone: "",
        legalPersonPhone: "",
      },
      loanInfo: {
        amount: "",
        term: "",
        operatingYears: "",
        annualTurnover: "",
        purpose: "",
        purposeCode: "",
        purposeDescription: "",
      },
      pledgeInfo: {
        isPledge: "0",
        warehouseReceiptNo: "",
        pledgeQuantity: "",
        selectedWarehouse: null, // 选中的仓单对象
      },
      fileList: {
        businessLicense: [],
        legalPersonIdCard: [],
        supplementaryMaterials: [],
      },
      showProductTypePicker: false,
      showPurposePicker: false,
      showAgreementDialog: false,
      showWarehousePicker: false, // 仓单选择弹窗
      warehouseList: [], // 仓单列表
      tempSelectedWarehouse: null, // 临时选中的仓单
    };
  },
  computed: {
    currentPurposeColumns() {
      // 接口已返回完整的用途选项，直接使用即可
      return this.purposePickerOptions || [];
    },
  },
  methods: {
    nextStep() {
      if (this.currentStep === 1) {
        this.currentStep = 2;
      }
    },
    onProductTypeConfirm(value) {
      this.productType = value;
      // 重置用途选择，等待用户重新选择以联动 productTypeId
      this.loanInfo.purpose = "";
      this.loanInfo.purposeCode = "";
      this.productTypeId = null;
      this.showProductTypePicker = false;
    },
    onPurposeConfirm(value) {
      if (value && typeof value === "object") {
        this.loanInfo.purpose = value.text || value.label || value.name || "";
        this.loanInfo.purposeCode = value.value || value.param || "";
        this.productType = value.loanTypeName || this.productType || "";
        this.productTypeId = value.productTypeId ?? this.productTypeId;
      } else {
        this.loanInfo.purpose = value;
        this.loanInfo.purposeCode = "";
      }
      this.showPurposePicker = false;
    },
    // 通过 loanTypeId 获取产品类型与资金用途选项
    async initProductTypesAndPurpose() {
      if (!this.loanTypeId) return;
      const headers = {
        access_token: this.accessToken,
        identityType: this.identityTypeCode,
        identityId: this.identityId,
      };

      try {
        const res = await financeTypeByIds([
          { loanTypeId: this.loanTypeId },
          headers,
        ]);
        if (res && res.code === 0) {
          const data = res.data || [];
          // 直接映射为用途选择器选项
          this.purposePickerOptions = (Array.isArray(data) ? data : []).map(
            (item) => ({
              text: item.fundUsageDesc,
              value: String(item.fundUsageParam),
              productTypeId: item.productTypeId,
              loanTypeName: item.loanTypeName,
            })
          );

          // 产品类型选项（去重）
          this.productTypeOptions = Array.from(
            new Set(
              (Array.isArray(data) ? data : [])
                .map((d) => d.loanTypeName)
                .filter(Boolean)
            )
          );

          // 默认使用第一项联动产品类型
          if (!this.productType && this.purposePickerOptions.length) {
            const first = this.purposePickerOptions[0];
            this.productType = first.loanTypeName || "";
            this.productTypeId = first.productTypeId ?? null;
          }
        }
      } catch (err) {
        console.error("initProductTypesAndPurpose error:", err);
      }
    },
    submit() {
      // 先校验必填项，校验通过再弹出协议框
      if (!this.validateForm()) return;
      this.showAgreementDialog = true;
    },
    cancel() {
      this.$router.go(-1);
    },
    handleAgreementConfirm() {
      // 用户已同意，直接发起提交请求
      this.submitForm();
    },
    handleAgreementCancel() {
      console.log("User disagreed with the terms.");
      this.showAgreementDialog = false;
    },

    // 仓单选择相关方法
    async getWarehouseReceiptList() {
      try {
        const res = await getWarehouseReceiptListH5({
          Authorization: `Bearer ${this.accessToken}`,
          "Identity-Type": this.identityTypeCode,
          "Identity-Id": this.identityId,
        });
        if (res && res.code === 0 && Array.isArray(res.data)) {
          const defaultItem = {
            id: "-1",
            warehouseReceiptNo: "待入仓单",
            warehouseName: "待入仓单",
            productName: "待入仓单",
            balanceWeight: 0,
          };
          this.warehouseList = [
            defaultItem,
            ...res.data.map((item) => ({
              id: item.id,
              warehouseId: item.warehouseId || item.id,
              warehouseReceiptNo: item.number || item.warehouseReceiptNo || "",
              warehouseName: item.warehouseName || "",
              productName: item.grainCategoryName || item.productName || "",
              balanceWeight: item.balanceWeight || 0,
              pledgeWeight: item.pledgeWeight || 0,
              dispatchingWeight: item.dispatchingWeight || 0,
            })),
          ];
        } else {
          this.warehouseList = [
            {
              id: "-1",
              warehouseReceiptNo: "待入仓单",
              warehouseName: "待入仓单",
              productName: "待入仓单",
              balanceWeight: 0,
            },
          ];
          Toast((res && res.msg) || "未获取到仓单数据");
        }
      } catch (error) {
        console.error("获取仓单列表失败:", error);
        Toast("获取仓单列表失败");
      }
    },

    showWarehouseList() {
      this.getWarehouseReceiptList();
      // 设置之前选中的仓单到临时选中状态
      this.tempSelectedWarehouse = this.pledgeInfo.selectedWarehouse;
      this.showWarehousePicker = true;
    },

    closeWarehouseList() {
      this.showWarehousePicker = false;
      // 不要重置 tempSelectedWarehouse，以保持选中状态
    },

    selectWarehouse(warehouse) {
      this.tempSelectedWarehouse = warehouse;
    },

    confirmWarehouse() {
      if (this.tempSelectedWarehouse) {
        this.pledgeInfo.selectedWarehouse = this.tempSelectedWarehouse;
        this.pledgeInfo.warehouseReceiptNo =
          this.tempSelectedWarehouse.warehouseReceiptNo;
        this.closeWarehouseList();
      }
    },

    clearWarehouseSelection() {
      this.pledgeInfo.selectedWarehouse = null;
      this.pledgeInfo.warehouseReceiptNo = "";
      this.pledgeInfo.pledgeQuantity = "";
    },
    // 补充材料上传（参考 dksq.vue 的上传逻辑）
    async afterReadSupplementary(file) {
      // 兼容单文件与多文件；直接更新当前文件项，避免与 v-model 重复添加
      const items = Array.isArray(file) ? file : [file];
      for (const item of items) {
        try {
          const realFile = item.file;
          // 类型限制：仅允许图片或 PDF
          const mime = realFile && realFile.type;
          const isImage = mime && /^image\//.test(mime);
          const isPdf = mime === "application/pdf";
          if (!isImage && !isPdf) {
            item.status = "failed";
            item.message = "不支持的文件类型";
            Toast.fail("仅支持图片或PDF文件");
            continue;
          }

          item.status = "uploading";
          item.message = "上传中...";

          const param = new FormData();
          param.append("file", realFile);
          const res = await uploadFile(param);

          if (!res || !res.data || !res.data.url) {
            item.status = "failed";
            item.message = "上传失败";
            Toast.fail("上传失败：服务未返回文件地址");
            continue;
          }

          const ossUrl = res.data.url; // 原始 OSS 路径
          const previewUrl = `${baseUrl}/admin/file/get?ossFilePath=${ossUrl}`;

          // 直接更新当前项以用于预览与提交
          item.url = previewUrl;
          item.ossUrl = ossUrl;
          item.name = res.data.sourceFileName || realFile?.name || "附件";
          item.status = "done";
          item.message = "";
        } catch (err) {
          console.error("afterReadSupplementary upload error:", err);
          item.status = "failed";
          item.message = "上传失败";
          Toast.fail("上传失败，请稍后重试");
        }
      }
    },
    validateForm() {
      if (!this.loanInfo.amount) {
        Toast("请输入贷款申请金额");
        return false;
      }
      if (Number(this.loanInfo.amount) <= 0) {
        Toast("贷款申请金额需为正数");
        return false;
      }
      if (!this.loanInfo.term) {
        Toast("请输入贷款期限");
        return false;
      }
      if (Number(this.loanInfo.term) <= 0) {
        Toast("贷款期限需为正数");
        return false;
      }
      if (!this.loanInfo.operatingYears) {
        Toast("请输入经营年限");
        return false;
      }
      if (Number(this.loanInfo.operatingYears) <= 0) {
        Toast("经营年限需为正数");
        return false;
      }
      if (!this.loanInfo.annualTurnover) {
        Toast("请输入年营业额");
        return false;
      }
      if (Number(this.loanInfo.annualTurnover) <= 0) {
        Toast("年营业额需为正数");
        return false;
      }
      if (!this.loanInfo.purpose) {
        Toast("请选择贷款资金用途");
        return false;
      }
      if (!this.loanInfo.purposeDescription) {
        Toast("请输入用途说明");
        return false;
      }

      // 仓单贷特殊验证
      if (this.productType === "仓单贷") {
        // 必须选择仓单（包括待入仓）
        if (!this.pledgeInfo.selectedWarehouse) {
          Toast("请选择仓单");
          return false;
        }
        // 质押数量必填，且为大于0的整数（待入仓也需填写）
        const qtyNum = Number(this.pledgeInfo.pledgeQuantity);
        if (!qtyNum || !Number.isInteger(qtyNum) || qtyNum <= 0) {
          Toast("质押数量需为大于0的整数");
          return false;
        }
        // 当选择的是非待入仓单时，需校验不超过可抵押数量
        if (this.pledgeInfo.selectedWarehouse.id !== "-1") {
          const balanceWeight =
            this.pledgeInfo.selectedWarehouse.balanceWeight || 0;
          if (qtyNum > balanceWeight) {
            Toast(`抵押数量不能大于可抵押数量${balanceWeight}KG`);
            return false;
          }
        }
      } else if (
        this.pledgeInfo.isPledge === "1" &&
        !this.pledgeInfo.warehouseReceiptNo
      ) {
        Toast("请输入仓单号");
        return false;
      }
      return true;
    },
    async submitForm() {
      // 构造附件文件列表（仅处理补充材料）
      const files = (this.fileList.supplementaryMaterials || []).map((f) => ({
        FilesName: f.name || f.fileName || "附件",
        // 优先使用原始 OSS 路径，其次退回到预览地址
        imgUrl: f.ossUrl || f.url || "",
      }));
      // 如需调试可保留日志，但不提前返回，避免后续代码不可达
      // console.log(this.fileList.supplementaryMaterials);

      // 单位换算：金额/营业额（万元 → 元）
      const amountYuan = this.loanInfo.amount
        ? Math.round(Number(this.loanInfo.amount) * 10000)
        : undefined;
      const turnoverYuan = this.loanInfo.annualTurnover
        ? Math.round(Number(this.loanInfo.annualTurnover) * 10000)
        : undefined;

      // 按 111-250 段的参数构造提交体（映射到服务端常用字段名）
      const payload = {
        productType: this.productType,
        productTypeId: this.productTypeId,
        financeProductId: this.financeProductId, // 所属部门所用产品id
        money: amountYuan, // 贷款申请金额（元）
        operatYear: this.loanInfo.operatingYears, // 经营年限（年）
        income: turnoverYuan, // 年营业额（元）
        loanTerm: this.loanInfo.term, // 贷款期限（月）
        fundUsage: this.loanInfo.purposeCode, // 贷款资金用途
        use: this.loanInfo.purposeDescription, // 用途说明
        files: JSON.stringify(files), // 补充材料
      };

      // 仓单贷字段（仅在选择仓单时附带）
      if (this.productType === "仓单贷" && this.pledgeInfo.selectedWarehouse) {
        payload.warehouseId =
          this.pledgeInfo.selectedWarehouse.warehouseId ||
          this.pledgeInfo.selectedWarehouse.id;
        payload.warehouseCode =
          this.pledgeInfo.selectedWarehouse.warehouseReceiptNo ||
          this.pledgeInfo.warehouseReceiptNo;
        // 提交为整数
        payload.warehouseNumber =
          parseInt(this.pledgeInfo.pledgeQuantity, 10) || 0;
      }

      const headers = {
        access_token: this.accessToken,
        identityType: this.identityTypeCode,
        identityId: this.identityId,
      };

      try {
        const res = await farmerAndCompanyApply([payload, headers]);
        if (res && res.code === 0) {
          Toast.success("提交成功");
          this.showAgreementDialog = false;
          wx?.miniProgram?.navigateTo({ url: "/pagesA/my-sqjl/sqjl" });
        } else {
          Toast.fail((res && res.msg) || "提交失败");
        }
      } catch (err) {
        console.error("ApplyLoanH5 submit error:", err);
        Toast.fail("提交失败，请稍后重试");
      }
    },
  },
  created() {
    // 读取 queryParams（包含身份与令牌）
    const qp = this.$route.query.queryParams || {};
    let qpObj = qp;
    if (typeof qp === "string") {
      try {
        qpObj = JSON.parse(qp);
      } catch (e) {
        qpObj = {};
      }
    }

    // 提取 access_token 与 identityObj
    this.accessToken = qpObj.access_token || qpObj.accessToken || "";
    let identityRaw =
      qpObj.identityObj || this.$route.query.queryParams?.identityObj;
    let identityObj = identityRaw;
    if (typeof identityRaw === "string") {
      try {
        identityObj = JSON.parse(identityRaw);
      } catch (e) {
        identityObj = {};
      }
    }
    this.identityId = identityObj.identityId || "";

    // 读取 loanTypeId（可能在 queryParams 或 query 上）
    const rawLoanTypeId =
      qpObj.loanTypeId ||
      this.$route.query.loanTypeId ||
      this.$route.query.queryParams?.loanTypeId;
    if (Array.isArray(rawLoanTypeId)) {
      this.loanTypeId = rawLoanTypeId.join(",");
    } else if (typeof rawLoanTypeId === "string") {
      this.loanTypeId = rawLoanTypeId;
    }

    // 读取 financeProductId（可能在 queryParams 或 query 上）
    const rawFinanceProductId =
      qpObj.financeProductId ||
      this.$route.query.financeProductId ||
      this.$route.query.queryParams?.financeProductId;
    if (typeof rawFinanceProductId === "string") {
      // 某些入口传入的是 JSON 字符串，尝试解析
      try {
        this.financeProductId = JSON.parse(rawFinanceProductId);
      } catch (e) {
        this.financeProductId = rawFinanceProductId;
      }
    } else if (rawFinanceProductId != null) {
      this.financeProductId = rawFinanceProductId;
    }

    const params = this.$route.query.queryParams?.identityObj;

    // 解析参数字符串（如果是字符串格式）
    let queryData = params;
    if (typeof params === "string") {
      try {
        queryData = JSON.parse(params);
      } catch (e) {
        queryData = {};
      }
    }

    // 记录身份类型代码（优先使用 identityObj 中的数据）
    this.identityTypeCode =
      identityObj.identityTypeCode || queryData.identityTypeCode || "";

    // 基于 loanTypeId 拉取产品类型和用途选项
    this.initProductTypesAndPurpose();

    // 处理身份类型为2（农户）
    if (this.identityTypeCode === "2") {
      const userAuth = queryData.sysUserAuth || {};
      // 姓名与身份证号、手机号映射
      this.applicantInfo.mainName =
        userAuth.realName || queryData.identityName || "";
      this.applicantInfo.creditCode =
        userAuth.cardId || queryData.identityCode || "";
      // 电话和人配对出现：严格使用账号（userName）作为手机号
      this.applicantInfo.contactPhone = queryData.userName || "";

      // 身份证图片（正反面）
      const idPhotos = [];
      if (userAuth.userCardFrontImg || userAuth.cardFront) {
        idPhotos.push({
          url: `${baseUrl}/admin/file/get?ossFilePath=${
            userAuth.userCardFrontImg || userAuth.cardFront
          }`,
          isImage: true,
        });
      }
      if (userAuth.userCardBackImg || userAuth.cardBack) {
        idPhotos.push({
          url: `${baseUrl}/admin/file/get?ossFilePath=${
            userAuth.userCardBackImg || userAuth.cardBack
          }`,
          isImage: true,
        });
      }
      this.fileList.legalPersonIdCard = idPhotos;
      // 农户没有营业执照
      this.fileList.businessLicense = [];

      // 处理identityTypeCode为4的情况（企业主体）
    } else if (this.identityTypeCode === "4" && queryData.sysCompanyAuth) {
      const companyAuth = queryData.sysCompanyAuth;

      // 回显企业基本信息
      this.applicantInfo.mainName = companyAuth.companyName || "";
      this.applicantInfo.creditCode = companyAuth.socialCreditId || "";
      this.applicantInfo.legalPerson = companyAuth.bossName || "";
      this.applicantInfo.contactName = companyAuth.contactName || "";
      this.applicantInfo.contactPhone = companyAuth.contactPhone || "";
      this.applicantInfo.legalPersonPhone = queryData.userName || "";

      // 处理营业执照图片 - 参考dksq.vue的拼凑方式
      if (companyAuth.businessLicense) {
        this.fileList.businessLicense = [
          {
            url: `${baseUrl}/admin/file/get?ossFilePath=${companyAuth.businessLicense}`,
            isImage: true,
          },
        ];
      }

      // 处理法人身份证图片（正反面）
      if (companyAuth.bossCardFront || companyAuth.bossCardBack) {
        const idCardImages = [];

        if (companyAuth.bossCardFront) {
          idCardImages.push({
            url: `${baseUrl}/admin/file/get?ossFilePath=${companyAuth.bossCardFront}`,
            isImage: true,
          });
        }

        if (companyAuth.bossCardBack) {
          idCardImages.push({
            url: `${baseUrl}/admin/file/get?ossFilePath=${companyAuth.bossCardBack}`,
            isImage: true,
          });
        }

        this.fileList.legalPersonIdCard = idCardImages;
      }
    } else {
      // 处理其他情况或通用参数
      if (queryData.productType) {
        this.productType = queryData.productType;
      }
      if (queryData.mainName) {
        this.applicantInfo.mainName = queryData.mainName;
      }
      if (queryData.creditCode) {
        this.applicantInfo.creditCode = queryData.creditCode;
      }
      if (queryData.legalPerson) {
        this.applicantInfo.legalPerson = queryData.legalPerson;
      }
      if (queryData.contactName) {
        this.applicantInfo.contactName = queryData.contactName;
      }
      if (queryData.contactPhone) {
        this.applicantInfo.contactPhone = queryData.contactPhone;
      }
      if (queryData.legalPersonPhone) {
        this.applicantInfo.legalPersonPhone = queryData.legalPersonPhone;
      }
      if (queryData.amount) {
        this.loanInfo.amount = queryData.amount;
      }
      if (queryData.term) {
        this.loanInfo.term = queryData.term;
      }
      if (queryData.operatingYears) {
        this.loanInfo.operatingYears = queryData.operatingYears;
      }
      if (queryData.annualTurnover) {
        this.loanInfo.annualTurnover = queryData.annualTurnover;
      }
      if (queryData.purpose) {
        this.loanInfo.purpose = queryData.purpose;
      }
      if (queryData.isPledge) {
        this.pledgeInfo.isPledge = queryData.isPledge;
      }
      if (queryData.warehouseReceiptNo) {
        this.pledgeInfo.warehouseReceiptNo = queryData.warehouseReceiptNo;
      }
      if (queryData.pledgeQuantity) {
        this.pledgeInfo.pledgeQuantity = queryData.pledgeQuantity;
      }

      // 模拟获取系统带入的图片（作为回退）
      if (!this.fileList.businessLicense.length) {
        this.fileList.businessLicense = [
          { url: "/imgs/logo.png", isImage: true },
        ];
      }
      if (!this.fileList.legalPersonIdCard.length) {
        this.fileList.legalPersonIdCard = [
          { url: "/imgs/logo.png", isImage: true },
          { url: "/imgs/logo.png", isImage: true },
        ];
      }
    }
  },
};
</script>

<style scoped>
.apply-loan-h5 {
  padding: 16px;
  padding-bottom: 80px; /* 为悬浮按钮留出空间 */
}

.van-cell-group {
  margin-bottom: 16px;
}

.button-group {
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: center;
  gap: 12px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
}

.agreement-content {
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;
}

/* 基本信息确认卡片样式 */
.info-confirm-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
  overflow: hidden;
}

.info-header {
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  color: white;
  padding: 12px 16px;
}

.info-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.info-content {
  padding: 16px;
}

.info-section {
  margin-bottom: 12px;
}

.info-section:last-child {
  margin-bottom: 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
  padding: 4px 0;
}

.info-label {
  font-weight: 500;
  color: #666;
  min-width: 100px;
  flex-shrink: 0;
  font-size: 14px;
}

.info-value {
  color: #333;
  text-align: right;
  flex: 1;
  word-break: break-all;
  font-size: 14px;
}

/* 图片预览样式 */
.image-preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.preview-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid #e8e8e8;
  cursor: pointer;
  transition: all 0.2s ease;
}

.preview-image:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.clickable-file {
  color: #1890ff;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.clickable-file:hover {
  color: #40a9ff;
}

.info-footer {
  background: #f8f9fa;
  padding: 12px 16px;
  border-top: 1px solid #e9ecef;
}

.info-tip {
  margin: 0;
  font-size: 12px;
  color: #6c757d;
  line-height: 1.4;
}

/* van-uploader紧凑样式 */
.compact-uploader {
  margin: 0 !important;
}

.compact-uploader .van-uploader__preview {
  margin: 0 4px 0 0 !important;
}

.compact-uploader .van-uploader__preview-image {
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.compact-uploader .van-uploader__preview-image:hover {
  transform: scale(1.05);
}

/* 仓单选择弹窗样式 */
.warehouse-picker {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.picker-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* 质押数量单位样式 */
.unit-kg {
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 28px;
  line-height: 28px;
  margin-left: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  color: #666;
  background: #fafafa;
  font-size: 12px;
}

.close-icon {
  font-size: 18px;
  color: #999;
  cursor: pointer;
}

.warehouse-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
}

.warehouse-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.warehouse-item:last-child {
  border-bottom: none;
}

.warehouse-item:hover {
  background-color: #f9f9f9;
}

.warehouse-item.selected {
  background-color: #e6f7ff;
  border-left: 4px solid #1890ff;
  margin-left: -4px;
  padding-left: 12px;
}

.warehouse-info {
  flex: 1;
}

.warehouse-no {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.warehouse-details {
  display: flex;
  gap: 12px;
  margin-bottom: 4px;
}

.warehouse-name {
  font-size: 14px;
  color: #666;
}

.warehouse-product {
  font-size: 14px;
  color: #888;
}

.warehouse-balance {
  font-size: 13px;
  color: #52c41a;
  font-weight: 500;
}

.selected-icon {
  color: #1890ff;
  font-size: 18px;
  margin-left: 8px;
}

.empty-tips {
  padding: 40px 0;
  text-align: center;
}

.picker-footer {
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  background: white;
  position: sticky;
  bottom: 0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .info-label {
    min-width: auto;
    font-size: 14px;
  }

  .info-value {
    text-align: left;
    font-size: 15px;
  }

  .compact-uploader .van-uploader__preview {
    margin: 0 3px 0 0 !important;
  }

  .compact-uploader .van-uploader__preview-image {
    width: 50px !important;
  }
}

/* 仓单质押信息美化样式 */
.van-cell-group[title="仓单质押信息"] {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.van-cell-group[title="仓单质押信息"] .van-cell-group__title {
  background: linear-gradient(135deg, #ff6b35, #ff8e53);
  color: white;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
}

.van-cell-group[title="仓单质押信息"] .van-cell {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.van-cell-group[title="仓单质押信息"] .van-cell:last-child {
  border-bottom: none;
}

.van-cell-group[title="仓单质押信息"] .van-field__label {
  font-weight: 500;
  color: #333;
  font-size: 15px;
}

.van-cell-group[title="仓单质押信息"] .van-field__control {
  font-size: 15px;
  color: #1890ff;
  font-weight: 500;
}

.van-cell-group[title="仓单质押信息"] .van-field__control::placeholder {
  color: #999;
  font-weight: normal;
}

.balance-text {
  color: #52c41a !important;
  font-weight: 500;
  font-size: 13px;
}

/* 仓单选择器美化 */
.van-cell-group[title="仓单质押信息"] .van-field--is-link::after {
  color: #1890ff;
}

.van-cell-group[title="仓单质押信息"]
  .van-field--required
  .van-field__label::before {
  color: #ff4d4f;
}

/* 数字输入框美化 */
.van-cell-group[title="仓单质押信息"] .van-field__control[type="number"] {
  text-align: right;
  color: #333;
}

/* 悬停效果 */
.van-cell-group[title="仓单质押信息"] .van-cell:active {
  background-color: #f7f7f7;
}

/* 深色模式适配 */
@media (prefers-color-scheme: dark) {
  .info-confirm-card {
    background: #2d3748;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  }

  .info-header {
    background: linear-gradient(135deg, #2c5282, #2b6cb0);
  }

  .info-row {
    border-bottom-color: #4a5568;
  }

  .info-label {
    color: #cbd5e0;
  }

  .info-value {
    color: #e2e8f0;
  }

  .info-footer {
    background: #2d3748;
    border-top-color: #4a5568;
  }

  .info-tip {
    color: #a0aec0;
  }
}

/* 单位文本样式 */
.unit-text {
  color: #666;
  font-size: 14px;
  font-weight: normal;
  margin-left: 4px;
  flex-shrink: 0;
}

/* 优化表单字段布局，防止文本换行 */
.van-cell-group[title="贷款申请信息"] .van-field__label {
  min-width: 80px;
  flex-shrink: 0;
  margin-right: 8px;
}

.van-cell-group[title="贷款申请信息"] .van-field__body {
  display: flex;
  align-items: center;
}

.van-cell-group[title="贷款申请信息"] .van-field__control {
  flex: 1;
  min-width: 0;
}

.van-cell-group[title="贷款申请信息"] .van-field__extra {
  margin-left: 8px;
  flex-shrink: 0;
}

/* 必填项星号样式 */
.van-field--required .van-field__label::before {
  color: #ff4d4f;
  margin-right: 4px;
  content: "*";
}
</style>
// 输入时将质押数量规范为整数 onPledgeQuantityInput(val) { const str =
String(val ?? ""); // 仅保留数字，去除非数字字符 const cleaned =
str.replace(/[^0-9]/g, ""); // 去除前导零 const normalized =
cleaned.replace(/^0+/, ""); this.pledgeInfo.pledgeQuantity = normalized; },
